export default defineNuxtPlugin(() => {
    const router = useRouter();

    const viewportConfigs = {
        default:
            "width=device-width, initial-scale=1.0, user-scalable=no, maximum-scale=2.0, minimum-scale=1.0",
        zoomable:
            "width=device-width, initial-scale=0.4, user-scalable=yes, maximum-scale=2.0, minimum-scale=0.4",
    };

    const isZoomableRoute = (route) => {
        const { name, path } = route;

        // Check by route name
        const zoomableRouteNames = [
            "routeplanning-date",
            // "kitchen-day-date",
            // "kitchen-day-date-order",
            // "kitchen-month-month",
            // "kitchen-week-kw",
        ];

        if (name && zoomableRouteNames.includes(name)) {
            return true;
        }
    };

    const applyViewport = (viewportContent) => {
        const meta = document.querySelector('meta[name="viewport"]');
        if (meta) {
            // Reset zoom first
            meta.content =
                "width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0";
            document.body.offsetHeight;

            requestAnimationFrame(() => {
                meta.content = viewportContent;
            });
        }
    };

    router.beforeEach((to) => {
        const viewportType = isZoomableRoute(to) ? "zoomable" : "default";
        const targetViewport = viewportConfigs[viewportType];

        nextTick(() => {
            applyViewport(targetViewport);
        });
    });

    // Handle initial load
    router.isReady().then(() => {
        const viewportType = isZoomableRoute(router.currentRoute.value)
            ? "zoomable"
            : "default";
        applyViewport(viewportConfigs[viewportType]);
    });
});
